import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";

const customRoutes = [
  { method: "GET", path: "/unread", handlerName: "getUnread" },
  { method: "POST", path: "/:id/mark-read", handlerName: "markAsRead" },
  { method: "POST", path: "/mark-all-read", handlerName: "markAllAsRead" },
  { method: "GET", path: "/by-type/:type", handlerName: "getByType" },
  { method: "GET", path: "/pending-authorization-alerts", handlerName: "getPendingAuthorizationAlerts" },
  { method: "POST", path: "/:id/approve-authorization-alert", handlerName: "approveAuthorizationAlert" },
  { method: "POST", path: "/:id/reject-authorization-alert", handlerName: "rejectAuthorizationAlert" },
  { method: "GET", path: "/preview-ai-email/:authorizationId", handlerName: "previewAIEmail" },
  { method: "POST", path: "/:id/regenerate-ai-content", handlerName: "regenerateAIContent" },
];

export const notificationsService = createCrudService("notifications", customRoutes, router);